<template>
  <b-row>
    <b-col cols="12" md="4">
      <div class="grouper-info w-100">
        <div class="pb-2">
          <h1 class="mb-4 title"><slot></slot></h1>
          <div class="story-main-container">
            <Story
              v-for="(s, i) in items"
              :key="i"
              :image="s.thumbnail"
              :image-alt="s.name"
              :to="$urlBuilder(type, { slug: s.slug })"
              :item-index="i"
              :active="isItemActive(s)"
              :show-image="showStoryImage"
              @reset-timer-item="resetTimer"
              @pause="pause"
              @resume="resume"
            />
          </div>
          <div v-if="activeItem">
            <div class="item-title">{{ activeItem.name }}</div>
            <div class="item-description">{{ activeItem.description }}</div>
            <div class="my-2">
              <Button
                shape="outline"
                size="medium"
                color="white"
                text="gray"
                hover="exp"
                :to="itemLink(activeItem)"
                >See {{ type }}</Button
              >
            </div>
          </div>
        </div>
      </div>
    </b-col>
    <b-col
      v-if="activeItem"
      cols="12"
      md="8"
      class="img-container overflow-hidden d-flex justify-content-center align-items-center"
    >
      <img
        width="730"
        height="850"
        :src="activeItem.header"
        class="w-100 img-fluid"
        :alt="activeItem.name"
        loading="lazy"
      />
    </b-col>
  </b-row>
</template>

<script>
import Story from 'UI/Story';
import Button from 'UI/Button';

export default {
  components: {
    Story,
    Button
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => []
    },
    type: {
      type: String,
      required: false,
      default: 'style'
    },
    showStoryImage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      activeItemIndex: 0,
      timerId: 0,
      startTime: new Date(),
      startResume: 0,
      startTimeout: 0,
      timeDiff: 0,
      remaining: 0,
      state: '',
      interval: 4000
    };
  },
  computed: {
    activeItem() {
      return this.items[this.activeItemIndex];
    }
  },
  mounted() {
    this.startTime = new Date();
    this.startInterval();
    this.state = 'running';
  },
  methods: {
    nextItem() {
      this.activeItemIndex =
        this.activeItemIndex + 1 >= this.items.length ? 0 : this.activeItemIndex + 1;
    },
    isItemActive(item) {
      return item && this.activeItem ? item.id == this.activeItem.id : false;
    },
    itemLink(item) {
      return this.$urlBuilder(this.type, { slug: item.slug });
    },
    pause(active) {
      if (active) {
        if (this.state === 'paused') return;

        if (this.state === 'resuming') {
          clearTimeout(this.startTimeout);
          this.timeDiff = this.timeDiff + (new Date() - this.startResume);
        } else {
          this.timeDiff = new Date() - this.startTime;
        }
        this.remaining = this.interval - this.timeDiff;
        clearInterval(this.timerId);
        this.state = 'paused';
      } else if (this.state === 'resetting') {
        clearInterval(this.timerId);
      }
    },
    resume(active) {
      if (active) {
        if (this.state === 'resetting') {
          this.resetTimer();
          this.state = 'running';
          this.remaining = this.interval;
          return;
        }
        if (this.state != 'paused') return;
        this.startResume = new Date();
        this.state = 'resuming';
        this.startTimeout = setTimeout(this.timeoutCallback, this.remaining);
      }
    },
    resetTimer(id) {
      clearTimeout(this.startTimeout);
      clearInterval(this.timerId);
      if (id != undefined) {
        this.activeItemIndex = id;
      }
      this.timerId = 0;
      this.startTime = new Date();
      this.startResume = 0;
      this.startTimeout = 0;
      this.timeDiff = 0;
      this.remaining = 0;
      this.startInterval();
      this.state = 'resetting';
    },
    timeoutCallback() {
      if (this.state != 'resuming') return;

      this.startTime = new Date();
      this.nextItem();
      this.startInterval();
      this.state = 'running';
    },
    startInterval() {
      this.timerId = setInterval(() => {
        this.startTime = new Date();
        this.nextItem();
      }, this.interval);
    }
  }
};
</script>

<style lang="scss" scoped>
.grouper-info {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
  .title {
    font-size: 2.5em;
    font-weight: 500;
    line-height: 1.2;
    margin-top: 45px;
    @include md {
      margin-top: 20px;
    }
  }
  .item-title {
    margin: 10px 0;
    font-size: 1.5em;
  }
  .item-description {
    color: $gray;
    font-size: 13px;
    margin: 10px 0 20px;
  }
  .story-main-container {
    display: flex;
    margin: 10px 0;
  }
}
.img-container {
  height: 500px;
}
</style>
